import dynamic from 'next/dynamic';
import { MainNavigationProps } from './main-navigation';

export const MainNavigation = dynamic<MainNavigationProps>(() =>
    import('./main-navigation').then((mod) => mod.MainNavigation)
);
